/**
 * sw-atc-drawer.js — progressive-enhancement AJAX add-to-cart voor de
 * compacte koopknoppen in de redesign-landingssecties (werkstroom
 * "cart-drawer", redesign-branch ai/auto/2026-07-03-switss-redesign).
 *
 * PROBLEEM (audit): snippets/sw-product-herozoom.liquid (form-class
 * .sw-phz-chip__form) en snippets/sw-product-subnav.liquid (form-class
 * .sw-subnav__buy-form) gebruiken een kale `{% form 'product', product %}`
 * -- zonder <product-form>-custom-element-wrapper, dus zonder de AJAX-
 * afhandeling die assets/product-form.js daar normaal aan toevoegt. Een
 * klik op "Koop" deed daardoor een volledige page-load POST naar
 * routes.cart_add_url i.p.v. de cart-drawer te openen.
 *
 * OPLOSSING: exact hetzelfde patroon als assets/product-form.js
 * (fetchConfig('javascript') + FormData + sections-parameter + JSON-
 * response -> cart.renderContents(response)), maar document-breed
 * gedelegeerd (zelfde stijl als sw-color-picker.liquid) i.p.v. per-
 * instantie custom element, omdat deze knoppen geen eigen wrapper-
 * element hebben en er twee onafhankelijke instanties per pagina
 * kunnen staan (hero-koopchip + sticky subnav).
 *
 * Zonder JS, of als er geen <cart-drawer> op de pagina staat (bv.
 * settings.cart_type != "drawer"): deze listener grijpt dan niet in,
 * de bestaande kale form-POST-fallback blijft intact (progressive
 * enhancement, geen regressie).
 *
 * Contract-attributen data-sw-atc-id / data-sw-atc-btn (kaart #166,
 * sw-color-picker.liquid) worden hier alleen GELEZEN (via FormData /
 * querySelector) -- dit script herschrijft geen markup en verandert
 * geen van beide attributen.
 */
(function () {
  if (window.__swAtcDrawerInit) return;
  window.__swAtcDrawerInit = true;

  var FORM_SELECTOR = '.sw-phz-chip__form, .sw-subnav__buy-form';

  function getSubmitButton(form) {
    return form.querySelector('[data-sw-atc-btn]') || form.querySelector('[type="submit"]');
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function' || !form.matches(FORM_SELECTOR)) return;

    var cart = document.querySelector('cart-drawer');
    // Geen drawer op deze pagina (bv. cart_type != "drawer"): niets
    // onderscheppen, de kale form-POST-fallback naar /cart/add blijft
    // gewoon werken.
    if (!cart) return;

    var submitButton = getSubmitButton(form);
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') {
      // Al een verzoek onderweg voor DIT formulier: negeer de dubbele klik.
      event.preventDefault();
      return;
    }

    event.preventDefault();

    var hadError = false;

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
    }

    // Zelfde fetch-opzet als assets/product-form.js.
    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData(form);
    formData.append(
      'sections',
      cart.getSectionsToRender().map(function (section) { return section.id; }).join(',')
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          hadError = true;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'sw-atc-drawer',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
          }
          // Shopify-cartfout (bv. net uitverkocht geraakt tussen page-load
          // en klik): terugvallen op de normale, niet-onderschepte
          // form-POST i.p.v. de fout stil te slikken. form.submit() vuurt
          // GEEN nieuw 'submit'-event (spec), dus geen lus met deze
          // listener.
          form.submit();
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sw-atc-drawer', productVariantId: formData.get('id') });
        }

        cart.renderContents(response);
      })
      .catch(function (err) {
        hadError = true;
        console.error('sw-atc-drawer:', err);
        // Netwerkfout: zelfde terugval als hierboven.
        form.submit();
      })
      .finally(function () {
        if (!submitButton) return;
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (!hadError) submitButton.removeAttribute('aria-disabled');
      });
  }

  // Capture-fase op window (kaart #563): Shopify telt zelf een submit naar
  // /cart/add als add-to-cart wanneer die bij zijn eigen listener nog niet
  // defaultPrevented is, en telt de AJAX-call daarna nog een keer. Met de
  // gewone bubble-listener op document kwam preventDefault() te laat en
  // kreeg elke klik twee add_to_cart-events (GA4, Google Ads, Meta). In de
  // capture-fase is de submit al afgevangen voordat Shopify hem ziet; de
  // koopblok-formulieren luisteren op het formulier zelf en hadden dit niet.
  window.addEventListener('submit', onSubmit, true);
})();
